export default {
  toastr (state, payload) {
    state.toastr.visibility = true
    state.toastr.text = payload.texto
    state.toastr.color = payload.color
    if (payload.time) {
      state.toastr.time = payload.time
    } else {
      state.toastr.time = 2000
    }
  },
  toastrAxiosError (state, payload) {
    try {
      if (payload.response.status === 401) {
        state.toastr.visibility = true
        state.toastr.text = 'sua sessão está encerrada'
        state.toastr.color = 'error'
      }
    } catch (error) {
      console.log(error)
      state.toastr.visibility = true
      state.toastr.text = 'Sem conexão com a internet'
      state.toastr.color = 'info'
    }
  },
  toastrApiError (state, payload) {
    state.toastr.visibility = true
    state.toastr.text = payload[0].errorMessage
    state.toastr.color = 'info'
  }
}



// WEBPACK FOOTER //
// ./src/store/toastr/mutations.js